import '../styling/NewCreateInvoiceForm.css';
import userimage from '../resources/invoice.png'
import {useState} from 'react';
import {useEffect} from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import { useInvoiceContext } from '../hooks/useInvoiceContext';
import AddClientList from '../components/AddClientList';
import API_BASE_URL from '../config.js';


const NewCreateInvoiceForm = ({handleSuccess,handleError}) => {
    const {user} = useAuthContext();

    const {dispatch} = useInvoiceContext()

    const [client,setClient]= useState(null)
    const [clientListState, setClientListState] = useState(null)
    const[clientFirst, setClientFirst] = useState('')
    const[clientLast, setClientLast] = useState('')
    const[issuedDate, setIssuedDate] = useState('')
    const[paymentDue, setPaymentDue] = useState('Upon receipt')
    const[invoiceSubject, setInvoiceSubject] = useState('')


    // client info:
    const[clientMessage, setClientMessage] = useState('')

    // quote info 
    const[invoiceTotal,setInvoiceTotal] = useState('')
    const [lineItems, setLineItems] = useState([
      {
        productService: '',
        quantity: 0,
        unitPrice: 0,
        total: 0,
      },
    ]);

    //error info 
    const[error, updateError] = useState('')



    // here we will do our post request to add a quote 
    const handleSubmit = async (e) => {
      e.preventDefault()

      if(!user){
          handleError("You must be logged in!")
          return
      }

      
      if(client==null){
        handleError("You must select a client!")
        return
      }


      const invoice = {client: {clientFirst, clientLast, clientMessage}, lineItems, invoiceTotal, issuedDate, paymentDue, invoiceSubject}

      console.log(invoice)

      const response = await fetch(`${API_BASE_URL}/api/invoice`, {
          method: "POST",
          body: JSON.stringify(invoice),
          headers:{
              "Content-Type": 'application/json',
              "Authorization": `Bearer ${user.token}`
          }
      })

      const json = await response.json();

      if (!response.ok) {
        const errorMessage = typeof json.error === 'string' ? json.error : 'Please fill out all of the required fields';
        updateError(errorMessage);
        handleError(errorMessage);
    }

      if(response.ok){
          setClient(null)
          setClientMessage('')
          setInvoiceTotal('')
          setLineItems([
            {
              productService: '',
              quantity: 0,
              unitPrice: 0,
              total: 0,
            },
          ])
          setIssuedDate('')
          setPaymentDue('')
          setInvoiceSubject('')
          updateError("")
          console.log("New workout added", json)
          dispatch({type: "CREATE_INVOICE", payload: json})
          // updateSuccess("Quote added successfully!")
          handleSuccess("Invoice created successfully!")
      }



  }


    const updateCurrentClient = (currclient) => {
        setClient({currclient})
        setClientFirst(currclient.clientFirst)
        setClientLast(currclient.clientLast)
        console.log(client)
        setClientListState(null);
    }

    const showClientList = () => {
        setClientListState(true);
    }

      const addLineItem = () => {
        setLineItems([...lineItems, { productService: '', quantity: 0, unitPrice: 0, total: 0 }]);
      };
      
      const updateLineItem = (index, field, value) => {
        const updatedLineItems = [...lineItems];
        if (field=="quantity"){
            updatedLineItems[index].quantity = value;
            updatedLineItems[index].total = value * updatedLineItems[index].unitPrice;

            setLineItems(updatedLineItems);
        
        let newquotetotal = 0;
        for(let total in lineItems){
            newquotetotal += lineItems[total].total
        }
        setInvoiceTotal(`$ ${newquotetotal}`)
        }
        else if(field=="unitPrice"){
            updatedLineItems[index].unitPrice = value;
            updatedLineItems[index].total = value*updatedLineItems[index].quantity;
            setLineItems(updatedLineItems);
        
        let newquotetotal = 0;
        for(let total in lineItems){
            newquotetotal += lineItems[total].total
        }
        setInvoiceTotal(`$ ${newquotetotal}`)
        }
        else if(field=="productService"){
          updatedLineItems[index].productService = value;
          setLineItems(updatedLineItems)
        }
        
      };

      const handleDelete = (index) => {
        const updatedLineItems = lineItems.filter((item, i) => i !== index);
        setLineItems(updatedLineItems);

        let newquotetotal = 0;
        for(let total in updatedLineItems){
            newquotetotal += lineItems[total].total
        }
        setInvoiceTotal(`$ ${newquotetotal}`)
    };


    return ( 
         
        <form onSubmit={handleSubmit}>
        { clientListState ? <AddClientList updateCurrentClient={updateCurrentClient}></AddClientList> : 
        <div className="newcreatequoteformcontainer3">
            <div className="newclientitle3">
                <div className="invoiceformleft3">
                <div className="newformleftcircle" id="quotecircle3">
                <img src={userimage} alt="" />
                </div>
                <h1 className="text-3xl font-bold ml-4">Invoice for:</h1>
                {!client && <button className="btn btn-primary" id="createquoteaddclient" onClick={showClientList}>Add a client</button>}
                {client && <h1 className="text-3xl font-bold ml-4 ">{client.currclient.clientFirst} {client.currclient.clientLast}</h1> }
                {client && <button className="btn btn-primary" id="createquoteaddclient" onClick={showClientList}>Change client</button>}
                </div>

                <div className="invoiceformright3">
                    <div className="fr1">
                        <h1><b>Issued Date</b></h1>
                        <input type="date" placeholder="Type here" className="input input-bordered input-accent w-full max-w-xs" 
                         value={issuedDate}
                         onChange={(e) => setIssuedDate(e.target.value)}
                        />
                </div>

                <div className="fr2">
                        <h1><b>Payment Due</b></h1>
                        <select className="select select-accent w-full max-w-xs" 
                        value={paymentDue}
                        onChange={(e) => setPaymentDue(e.target.value)}>
                        <option disabled selected>Select a due date</option>
                        <option>Upon receipt</option>
                        <option>Net 15</option>
                        <option>Net 30</option>
                        <option>Net 45</option>
                        </select>
                    </div>
                    </div>
                </div>
                <div className="invoicesubject3">
                <h1 className="text-2xl font-bold">Invoice subject:</h1>
                <input type="text" placeholder="Enter Invoice Subject" className="input input-bordered input-accent w-full max-w-xl ml-6" 
                value={invoiceSubject}
                onChange={(e) => setInvoiceSubject(e.target.value)}
                />
                </div>
                <div className="newquoteformparams">
                    <h1 id="param01"><b>Product/Service</b></h1>
                    <h1 id="param2"><b>Quantity</b></h1>
                    <h1 id="param3"><b>Unit Price</b></h1>
                    <h1 id="param4"><b>Line Total</b></h1>
                    
                </div>

                {lineItems.map((item, index) => (
                <div className="itemlines" key={index}>
                <input
                type="text"
                placeholder="Enter Product/Service"
                className="input input-bordered input-success w-full max-w-xs"
                value={item.productService}
                 onChange={(e) => updateLineItem(index, 'productService', e.target.value)}
                />
                <input
                id="input2"
                type="number"
                placeholder="Enter Quantity"
                className="input input-bordered input-success w-half max-w-xs"
                value={item.quantity}
                onChange={(e) => updateLineItem(index, 'quantity', e.target.value)}
                />
                <input
                id="input2"
                type="number"
                placeholder="Enter Quantity"
                className="input input-bordered input-success w-half max-w-xs"
                value={item.unitPrice}
                onChange={(e) => updateLineItem(index, 'unitPrice', e.target.value)}
                />
                <h1>{item.total}$</h1>
                <div className="deleteitemdiv">
                <button className="btn btn-error btn-circle btn-outline" type="button" onClick={() => handleDelete(index)} >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
                </div> 
            </div>
            ))}

            <button className="btn btn-wide btn-outline btn-primary" id="addlineitem" type="button" onClick={addLineItem}>Add line item</button>

            <div className="messageandsave">
            <textarea className="textarea textarea-info textarea-lg w-full max-w-xs" placeholder="Client Message"
            value={clientMessage}
            onChange={(e) => setClientMessage(e.target.value)}
            >

            </textarea>
            <div className="totalnsave">
            <h1><b>Quote total: {invoiceTotal}</b></h1>
            <button className="btn btn-lg btn-outline btn-primary" type="submit" id="saveQuoteButton">Save quote</button>
            </div>
            </div>
        </div>
                }
        </form>
     );
}
 
export default NewCreateInvoiceForm;